// Rename the interface to describe what it actually is — the preferences payload
import {Signal} from '@angular/core';

export interface CookieConsentPreferences {
  advertising: boolean;
  analytics: boolean;
}

// Abstract class is now unambiguous, and Signal types correctly
export abstract class CookieConsentService {
  abstract preferences: Signal<CookieConsentPreferences>;
  abstract savePreferences(prefs: CookieConsentPreferences): void;
}
